module.exports = __webpack_public_path__ + "media/cq.02e531b2.mp4";